
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.94 17.967H22.006V4.033A2.048 2.048 0 0019.973 2a2.048 2.048 0 00-2.033 2.033v13.934H4.006A2.025 2.025 0 002 20a2.03 2.03 0 002.033 2.033h13.934v13.934c0 1.111.922 2.033 2.033 2.033a2.048 2.048 0 002.033-2.033V22.033h13.934A2.048 2.048 0 0038 20c0-1.111-.922-2.033-2.06-2.033z"}})])
          )
        }
      }
    